<template>
	<div>
		<h3>Pivottable Demo</h3>
		<vue-pivottable
		    :data="pivotData"
		    aggregatorName='Sum'
		    rendererName='Table'
		    :rows="[]"
		    :cols="['DESCRIPCION_GRUPO']"
		    :vals="['MONTO']"
		>
		</vue-pivottable>
		<h3>Pivottable Ui Demo</h3>
		<vue-pivottable-ui
		    :data="pivotData"
		    aggregatorName='Sum'
		    rendererName='Table'
		    :rows="[]"
		    :cols="['DESCRIPCION_GRUPO']"
		    :vals="['MONTO']"
		>
		</vue-pivottable-ui>
	</div>
</template>
<script type="text/javascript">
	import { VuePivottable, VuePivottableUi } from 'vue-pivottable'
	import 'vue-pivottable/dist/vue-pivottable.css'
	export default {
		components: {
			VuePivottable,
			VuePivottableUi
		},
		data: () => {
			return {
				pivotData: [],
			}
		},

		methods: {
			getData(){
				axios.post('/api/consultas/pivot').then(res=>{
					var dataPivot = res.data || []
					console.log('pruebas')
					
					if (dataPivot.length>0) {
						const columns = Object.keys(dataPivot[0])

						var values = []
						for (var i = 0; i < dataPivot.length; i++) {
							values.push(Object.values(dataPivot[i]))
						}
						values.unshift(columns)
						this.pivotData = values
						console.log('test')
						console.log(this.pivotData);

						/*$.pivotUtilities.tipsData = values
						$("#output").pivotUI(
							$.pivotUtilities.tipsData, {
								rows: [columns[0]],
								cols: ["DESCRIPCION_GRUPO"],
								vals: ["MONTO"],
								aggregatorName: "Sum",
								rendererName: "Table"
							});*/
					}else{
						//
					}
				}).catch(err => {
					//
				});
			}
		}
	}
</script>